// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"dabf0315"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import * as Sentry from '@sentry/nextjs';
import { replayIntegration } from '@sentry/nextjs';

const scriptConfigElement = window.document.getElementById('__SENTRY_CONFIG__');
let scriptConfig: Parameters<typeof Sentry.init>[0] | null = null;

if (scriptConfigElement && scriptConfigElement.textContent) {
  try {
    scriptConfig = JSON.parse(scriptConfigElement.textContent) as Parameters<
      typeof Sentry.init
    >[0];
  } catch (e) {
    console.error('Sentry config is not valid JSON');
  }
}

const config = global.__SENTRY_CONFIG_DATA__ ?? scriptConfig;

if (config) {
  Sentry.init({
    ...config,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    // Filter out React 18 hydration errors
    ignoreErrors: [
      // React 18 minified hydration error URLs (most reliable)
      'https://reactjs.org/docs/error-decoder.html?invariant=419',
      'https://reactjs.org/docs/error-decoder.html?invariant=422',
      'https://reactjs.org/docs/error-decoder.html?invariant=423',
      'https://reactjs.org/docs/error-decoder.html?invariant=425',
      // Text patterns for hydration errors
      'Hydration failed',
      'Text content does not match server-rendered HTML',
      'Warning: Text content did not match',
      'Warning: Expected server HTML to contain',
      // Add to existing patterns if any
      ...(config.ignoreErrors || []),
    ],

    beforeSend: (event) => {
      // Filter hydration-related errors
      if (event.message?.toLowerCase().includes('hydration')) {
        return null;
      }
      if (
        event.exception?.values?.some((exception) =>
          exception.value?.toLowerCase().includes('hydration'),
        )
      ) {
        return null;
      }
      return event;
    },

    // You can remove this option if you're not planning to use the Sentry Session Replay feature:
    integrations: [
      replayIntegration({
        // Additional Replay configuration goes in here, for example:
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
  });
}
